<template>
  <el-card>
    <level-form :data="detailInfo" @save="handleEditSubmit" />
  </el-card>
</template>

<script>
import LevelForm from "@/components/member-level/LevelForm";
import {request} from "@/config/request";
export default {
  name: "MemberLevelEdit",
  components: {LevelForm},
  data() {
    return {
      detailInfo: {}
    }
  },
  methods: {
    // 编辑提交
    async handleEditSubmit(data) {
      try {
        data["code"] = this.detailInfo.code;
        await request(this.$api.vipLevel.update, data);
        this.$message.success("操作成功");
        this.$router.back();
      } catch (e) {
        console.log(e);
      }
    },

    // 加载详情
    async loadDetail() {
      try {
        const res = await request(this.$api.vipLevel.detail, this.$route.query);
        this.detailInfo = res.vipLevel;
      } catch (e) {
        console.log(e);
      }
    }
  },
  created() {
    this.loadDetail();
  }
}
</script>

<style scoped>

</style>
